import authService from '@/services/auth.service'

export default {
  async login({ commit }, credentials) {
    const res = await authService.login(credentials)
    commit('SET_TOKEN', res.data.token)
    commit('SET_USER', res.data.user)
  },

  async acceptInvite({ commit }, credentials) {
    const res = await authService.acceptInvite(credentials)
    commit('SET_MESSAGE',res.message)
    return res
  },

  async forgotPassword({ commit }, credentials) {
    const res = await authService.forgotPassword(credentials)
    commit('SET_MESSAGE',res.message)
    return res
  },

  async resetPassword({ commit }, credentials) {
    const res = await authService.resetPassword(credentials)
    commit('SET_MESSAGE',res.message)
    return res
  },

  async logout({ commit }) {
    await authService.logout()
    commit('SET_TOKEN', null)
    commit('SET_USER', null)
  },
}
